export default __webpack_public_path__ + "static/media/agate_agnidus_c_chunk.ca2547c8.png";